<div class="p-20">
  <app-field-select
    label="Vehiculo"
    optionsUrl="mobiles/currents/choice"
    [value]="elementId"
    (valueChange)="onChangeMobile($event)"
  />

  @if (isLoading) {
    <mat-progress-bar mode="buffer"></mat-progress-bar>
  }


  <app-field-select
    label="Comando a enviar"
    [options]="options"
    [value]="commandKey"
    [style.opacity]="element ? 1: 0.4"

    (valueChange)="onChangeCommand($event)"
  />

  @if (commandKey === 'personalizeCommand'){
    <app-field-text label="Contenido personalizado" [(value)]="customText" />
  }

  <div [style.opacity]="element && commandKey ? 1: 0.4">
    @for (channel of channelList ; track channel){
      <mat-slide-toggle
        color="success"

        [disabled]="!channelAvailableKeys.includes(channel)"
        [checked]="channelToSent.has(channel)"
        (change)="toggleChannel(channel)"
      >
        <label>Enviar por {{ channel }}&nbsp;&nbsp;</label>
      </mat-slide-toggle>
    }
  </div>

  <div class="row">
    <div class="col-12">
      <br/>
    </div>
    <div class="col-12">
      <br/>
    </div>
    <div class="col-6 ">
      <div class="grid">
        <button
          mat-raised-button
          mat-flat-button color="primary"
          class="mat-body f-w-500"
          (click)="onSubmit()"
        >
          Enviar
        </button>
      </div>
    </div>
    <div class="col-6 ">
      <div class="grid">
        <button
          mat-raised-button
          mat-flat-button color="default"
          class="mat-body f-w-500"
          (click)="onCancel()"
        >
          Cancelar
        </button>
      </div>
    </div>
  </div>

</div>
